
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard } from '@/components';
import { useSubscriptionEdit } from '@/modules/subscription/item/model/edit';
import { ROUTE_NAME_SUBSCRIPTION } from '@/modules/subscription/router';

export default defineComponent({
    name: ROUTE_NAME_SUBSCRIPTION.EDIT,
    components: { AppFormRow, AppInput, AppButton, AppCard },
    setup() {
        const { model, v$, fetch, update } = useSubscriptionEdit();

        onMounted(() => {
            fetch();
        });

        return { v$, model, update };
    }
});
